export default "__VITE_ASSET__5vk80qQS__"